import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Unlink = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M16.949 14.121L19.071 12a5.008 5.008 0 000-7.071 5.006 5.006 0 00-7.071 0l-.707.707 1.414 1.414.707-.707a3.007 3.007 0 014.243 0 3.005 3.005 0 010 4.243l-2.122 2.121a2.723 2.723 0 01-.844.57L13.414 12l1.414-1.414-.707-.707a4.965 4.965 0 00-3.535-1.465c-.235 0-.464.032-.691.066L3.707 2.293 2.293 3.707l18 18 1.414-1.414-5.536-5.536c.277-.184.538-.396.778-.636zm-6.363 3.536a3.007 3.007 0 01-4.243 0 3.005 3.005 0 010-4.243l1.476-1.475-1.414-1.414L4.929 12a5.008 5.008 0 000 7.071 4.983 4.983 0 003.535 1.462A4.982 4.982 0 0012 19.071l.707-.707-1.414-1.414-.707.707z",
    key: "k0"
  }));
});
Unlink.displayName = 'Unlink';
export var UnlinkDimensions = {
  height: 24,
  width: 24
};